import { render } from "./MyActionSummaryWidget.vue?vue&type=template&id=93929af6&scoped=true"
import script from "./MyActionSummaryWidget.vue?vue&type=script&lang=js"
export * from "./MyActionSummaryWidget.vue?vue&type=script&lang=js"

import "./my-action-summary-widget.scss?vue&type=style&index=0&id=93929af6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\shame\\.codex\\.chatgpt-projects\\g-p-6a9e6467fc748191a03e695eb5ba59d5\\build-work\\hr-dependent-frontend\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93929af6"]])

export default __exports__